<template>
  <el-dialog :title="vendorName + '购买明细'"
             :visible.sync="visible"
             width="1160px"
             @close='handleClose'
             :close-on-press-escape="false">
    <el-table border
              v-loading="loading"
              :data="list">
      <el-table-column label="标签序号"
                       fixed="left"
                       min-width="170">
        <template slot-scope="{row}">
          {{row.beginTagNo | tagCount() }} - {{row.endTagNo | tagCount() }}
        </template>
      </el-table-column>
      <el-table-column label="标签类型"
                       min-width="120">
        <template slot-scope="{row}">
          {{row.tagType | tagType()}}
          <span v-if="row.tagType === 3">({{ row.tagHasCoat === 1 ? '有涂层' : '无涂层'}})</span>
        </template>
      </el-table-column>
      <el-table-column label="标签数量"
                       min-width="70"
                       prop="tagCount">
      </el-table-column>
      <el-table-column label="剩余数量"
                       min-width="70"
                       prop="remainCount">
      </el-table-column>
      <el-table-column label="坏码数量"
                       min-width="70"
                       prop="badTagCount">
      </el-table-column>
      <el-table-column label="防伪功能"
                       min-width="100">
        <template slot-scope="{row}">
          {{row.securityFuncFlag | securityFuncFlagName() }}
        </template>
      </el-table-column>
      <el-table-column label="地址前缀"
                       min-width="160"
                       prop="tagScanUrlPre">
      </el-table-column>
      <el-table-column label="备注"
                       v-if="userPermission.OPERATE"
                       min-width="160">
        <template slot-scope="{row}">
          {{row.remarks}}
          <i class="el-icon-edit"
             style="cursor: pointer;"
             @click="updatetagsegmentremarks(row)"></i>
        </template>
      </el-table-column>
      <el-table-column label="购买时间"
                       width="140">
        <template slot-scope="{row}">
          {{row.createdTime | dateformat() }}
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       fixed="right"
                       width="105">
        <template slot="header"
                  slot-scope="{ column }">
          <span>{{column.label}}</span>
          <el-tooltip placement="top">
            <div slot="content">
              <div>1.上传坏码只支持txt文件，</div>
              <div>2.输入当前所在行序号段范围内的标签序号</div>
              <div>3.txt文件中，标签一行一个，连续段请输入X-Y（如1-10）</div>
              <div>
                <div>4.如图</div>
                <img src="../../../assets/images/badtag_txt.png">
              </div>
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
        </template>
        <template slot-scope="{row}">
          <el-button type="text"
                     @click="downloadtagsegment(row)">下载</el-button>
          <!-- <el-button type="text"
                     icon="el-icon-upload2"
                     @click="upload(row)">上传坏码</el-button>
          <el-button type="text"
                     icon="el-icon-view"
                     @click="viewcode(row)">查看坏码</el-button> -->
          <el-dropdown>
            <el-button type="text"
                       style="margin-left: 10px;">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="upload(row)">上传坏码</el-dropdown-item>
              <el-dropdown-item @click.native="viewcode(row)">查看坏码</el-dropdown-item>
              <security-action-drop-item :row="row"
                                         v-model="loading"
                                         @fetch="gettagassigns" />
              <el-dropdown-item :disabled="row.securityFuncFlag === 0"
                                @click.native="viewList(row)">查询防伪码包</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background
                   @current-change="handleCurrentChange"
                   :current-page.sync="config.pageNum"
                   :page-size="config.pageSize"
                   layout="total, prev, pager, next"
                   :total="total">
    </el-pagination>
    <el-upload ref="elUpload"
               action=""
               :limit="1"
               style="display:none"
               accept=".txt"
               :show-file-list="false"
               :http-request="handleHttpRequest">
      <i ref="upload"></i>
    </el-upload>
    <template slot="footer">
      <el-button @click="gettagassigns()"
                 type="primary"
                 :loading="loading">刷新</el-button>
      <el-button @click="toggleModal(false)"
                 :loading="loading">关 闭</el-button>
    </template>
    <bad-tag-modal ref="bad"
                   :callback="gettagassigns" />
    <security-action-list-modal ref="securityActionList" />
  </el-dialog>
</template>
<script>
import BadTagModal from './bad-tag-modal'
import SecurityActionDropItem from './security-func-action/security-action-drop-item.vue'
import SecurityActionListModal from './security-func-action/security-action-list-modal.vue'
import { mapState } from 'vuex'
import Label from '@/service/label'
export default {
  name: 'ent-tag-detail-modal',
  components: { BadTagModal, SecurityActionDropItem, SecurityActionListModal },
  data () {
    return {
      loading: false,
      visible: false,
      vendorName: '',
      config: {
        vendorId: null,
        pageNum: 1,
        pageSize: 10,
        isPreassign: 1,
        isSetcode: 0
      },
      list: [],
      total: 0,
      current: {}
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission
    })
  },
  methods: {
    updatetagsegmentremarks (row) {
      this.$prompt('请输入备注', '修改备注', {
        confirmButtonText: '确定', cancelButtonText: '取消', inputPattern: /.+/, inputErrorMessage: '请输入备注'
      }).then(({ value }) => {
        this.loading = true
        Label.updatetagsegmentdetailsremarks({ tagSegDetailsId: row.tagSegDetailsId, remarks: value })
          .then(res => {
            this.loading = false
            const { result, message } = res.data
            if (result === 0) {
              this.$message.success('修改备注成功')
              this.gettagassigns()
            } else {
              this.$message.error(message)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error(err.message)
          })
        // this.$store.dispatch('label/updatetagsegmentremarks', {
        //   payload: { tagSegId: row.tagSegId, remarks: value },
        //   success: (res) => {
        //     this.loading = false
        //     this.gettagassigns()
        //   },
        //   fail: () => {
        //     this.loading = false
        //   }
        // })
      })
    },
    viewList (row) {
      this.$refs.securityActionList.fetch({
        tagSegDetailsId: row.tagSegDetailsId,
        vendorId: row.vendorId
      })
    },
    toggleModal (visible) {
      this.visible = visible
    },
    handleClose () {
      this.list = []
      this.total = 0
      this.config.pageNum = 1
      this.config.vendorId = null
    },
    downloadtagsegment (row) {
      this.loading = true
      this.$store.dispatch('label/downloadtagsegment', {
        payload: {
          tagSegId: row.tagSegId,
          tagSegDetailsId: row.tagSegDetailsId
        },
        success: (res) => {
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    gettagassigns (cb) {
      this.loading = true
      this.$store.dispatch('label/gettagsegmentdetailses', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.list = res.data.records
          this.total = res.data.total
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.gettagassigns()
    },
    fetch (options) {
      this.config.vendorId = options.vendorId
      this.vendorName = options.vendorName
      this.gettagassigns(() => {
        this.toggleModal(true)
      })
    },
    upload (row) {
      this.current = row
      this.$refs.upload.click()
    },
    handleHttpRequest (file) {
      // let formData = new FormData()
      // formData.append('file', file.file)
      // formData.append('tagSegDetailsId', this.current.batchId)
      // formData.append('vendorId', this.current.vendorId)
      let reader = new FileReader()
      reader.readAsText(file.file, 'gb2312')
      reader.onload = (e) => {
        var fileText = e.target.result.split('\n')
        this.loading = true
        this.$store.dispatch('label/addbadtags', {
          payload: {
            tagSegDetailsId: this.current.tagSegDetailsId,
            remarks: '',
            badTagSegs: fileText
          },
          success: (res) => {
            this.loading = false
            this.$message.success('上传成功')
            this.$refs.elUpload.clearFiles()
            this.gettagassigns()
          },
          fail: () => {
            this.$refs.elUpload.clearFiles()
            this.loading = false
          }
        })
      }
    },
    viewcode (row) {
      this.$refs.bad.fetch({
        tagSegDetailsId: row.tagSegDetailsId
      })
    }
  }
}
</script>
